import { Component, ErrorInfo, PropsWithChildren, ReactNode } from "react"

import Button from '../buttons/Button'

export interface ModalProps {
    title: string
    isError: boolean
    buttonText?: string
    isOpen?: boolean
    callBackToggle: Function
}

export interface ModalState {}

declare global {
  interface Window {
    Zuko: any
    goToElem: any
  }
}

class ModalNotification extends Component<PropsWithChildren<ModalProps>, ModalState> {

    constructor (props: any) {
        super(props)

        this.exit = this.exit.bind(this)
    }

    componentDidUpdate(prevProps: Readonly<PropsWithChildren<ModalProps>>, prevState: Readonly<ModalState>, snapshot?: any): void {
        let targetElement = document.querySelector(".notification-modal")

        if (this.props.isOpen) {    
            document.querySelector("body")?.classList.add("no-vertical-scrool")
            targetElement?.scrollIntoView( { behavior: 'smooth', block: 'start' } )
        }
        else {
            document.querySelector("body")?.classList.remove("no-vertical-scrool")
        }
    }

    render(): ReactNode {
        const classState = (this.props.isError) ? 'modal-error' : 'modal-success'

        return (
            (this.props.isOpen) &&
            <div className="modal-container">
                <div className="modal-fade-show notification-modal" tabIndex={-1}>
                    <div className={
                        'modal-dialog modal-dialog-centered modal-lg ' + classState
                    }>
                        <div className="modal-content">
                            <div className="modal-header">
                                <span className="modal-title titleLev4 colorPrimaryBlue mb-2">
                                    {this.props.title}
                                </span>
                                <button 
                                    type='button' 
                                    className='btn-close' 
                                    data-bs-dismiss='modal' 
                                    onClick={this.exit}
                                ></button>
                            </div>
                            <div className="modal-body">
                                {this.props.children}
                            </div>
                            <div className="modal-footer flex-column">
                                <Button 
                                    id='send-data'
                                    type="button" 
                                    className="btn btn-medium btn-secondary" 
                                    data-bs-dismiss="modal"
                                    onClick={this.exit}
                                >
                                    {this.props.buttonText ?? 'Chiudi'}
                                </Button>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-fade-backdrop"></div>
            </div>
        )
    }

    private exit () {
        // se presente sfrutto lo scrool incluso nelle pagine di wordpress
        const goToElem = window.goToElem
        const section = document.querySelector( '.is-invalid' ) ?? document.getElementById('formBlock')

        if (goToElem) {
            goToElem( section )
        } else {
            section?.scrollIntoView( { behavior: 'smooth', block: 'start' } )
        }

        this.props.callBackToggle ( false )
    }
}

export default ModalNotification